export function Loading() { return <div className="center"><span className="spinner" /> Se încarcă…</div>; }
export function ErrorBox({ message }: { message: string }) { return <div className="alert alert-error" role="alert">{message}</div>; }
